import React, { useState, useEffect, useContext } from 'react';
import './../agent_page.css'
import CancleSvg from '../../../assets/cancle.svg'
import dayjs from "dayjs";
import backArrow from '../../../assets/arrow_back.svg'
import { AppContext } from '../../../provider.jsx'
import { completeWork, downloadRequestDocument, getRequestDocument, showRequestDocument, adminPayAmount, getCaCsBankDetails } from '../../../controller/agent_data_controller';
import { assignCaCs, updateRequestStatus } from '../../../homepage/homepage_logic.js';
import { ShowCaCsList } from '../../../homepage/assign_ca_cs/show_ca_cs_list.jsx';

export const UpdateRequest = ({ requestData, callback }) => {
    const [showPopUp, setShowPopUp] = useState(false);
    const [files, setMyFiles] = useState([]);
    const [description, setDescription] = useState('');
    const [showCompleteWorkPopup, setShowCompleteWorkPopup] = useState(false);
    const [showCancelRequestPopup, setShowCancelRequestPopup] = useState(false);
    const [showPayAmountPopup, setShowPayAmountPopup] = useState(false);
    const [showPaymentDetailsPopup, setShowPaymentDetailsPopup] = useState(false);
    const [payAmount, setPayAmount] = useState('');
    const [paymentMethod, setPaymentMethod] = useState('Bank Transfer');
    const [transactionId, setTransactionId] = useState('');
    const [paymentNotes, setPaymentNotes] = useState('');
    const [payLoading, setPayLoading] = useState(false);
    const [documents, setDocumnets] = useState([]);
    const { selectedCaCsId } = useContext(AppContext);
    const { pageIndex, setPageIndex } = useContext(AppContext);
    const [assignLoading, setAssignLoading] = useState(false);
    const [completeLoading, setCompleteLoading] = useState(false);
    const [verifyLoading, setVerifyLoading] = useState(false);
    const [cancelRequestLoading, setCancelRequestLoading] = useState(false);
    const [cancelDescription, setCancelDescription] = useState('');
    const [paidInfo, setPaidInfo] = useState({
        amount: '',
        method: '',
        txnId: '',
        notes: '',
        paidAt: null,
    });
    const [caCsBankDetails, setCaCsBankDetails] = useState(null);
    const [caCsBankLoading, setCaCsBankLoading] = useState(false);

    const dateFormat = (timestamp) => {
        return dayjs(timestamp).format("DD MMM YYYY");
    };

    const [loading, setLoading] = useState(true);

    const fetchData = async () => {
        try {
            let result = await getRequestDocument(requestData[0]);
            setDocumnets(result);
            console.log('result:', result);
        } catch (err) {
            console.error("Error fetching:", err);
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        fetchData();
        window.scrollTo({ top: 0, behavior: "smooth" });
    }, []);

    if (loading) return <p>Loading...</p>;

    const overlayStyle = {
        position: 'fixed', inset: 0,
        backgroundColor: 'rgba(0,0,0,0.4)',
        zIndex: 999,
        display: 'flex', alignItems: 'center', justifyContent: 'center'
    };
    const modalStyle = {
        backgroundColor: 'white',
        borderRadius: '12px',
        padding: '30px',
        width: '420px',
        maxWidth: '95%',
        boxShadow: '0 8px 32px rgba(0,0,0,0.18)',
        position: 'relative',
        zIndex: 1000
    };

    return <div style={{ backgroundColor: 'rgba(246, 246, 249, 1)', minHeight: '100vh', paddingBottom: '30px' }}>
        {/* Top bar */}
        <div style={{ display: 'flex', alignItems: 'center', margin: '30px 50px 17px 42px', justifyContent: 'space-between' }}>
            <div style={{ display: 'flex', alignItems: 'center' }}>
                <div onClick={() => {
                    setPageIndex(0);
                    callback();
                }} className='submit-button-variable' style={{ marginRight: '30px' }}>
                    <span>🡐 back</span>
                </div>
                <p className='title-demo' style={{ margin: '0' }}>Request Details</p>
            </div>

            {/* Action buttons for non-terminal statuses */}
            {requestData[6] === 'Rejected' || requestData[6] === 'Paid' ? <></> :
                <div style={{ display: 'flex' }}>
                    <div
                        onClick={async () => {
                            if (verifyLoading) return;
                            if (requestData[6] === 'Under Review') {
                                setVerifyLoading(true);
                                const response = await updateRequestStatus(requestData[0], 'Approved', 'none');
                                if (response === 'success') {
                                    alert('Service Request Verified Successfully');
                                    requestData[6] = 'Approved';
                                    fetchData();
                                } else {
                                    alert(response);
                                }
                                setVerifyLoading(false);
                            } else if (requestData[6] === 'Approved') {
                                setShowPopUp(true);
                            } else if (requestData[6] === 'Assigned') {
                                setShowCompleteWorkPopup(true);
                            } else if (requestData[6] === 'Completed') {
                                setCaCsBankLoading(true);
                                const bankResult = await getCaCsBankDetails(requestData[9]);
                                setCaCsBankDetails(bankResult);
                                setCaCsBankLoading(false);
                                setShowPayAmountPopup(true);
                            }
                        }}
                        className='submit-button-variable' style={{ marginRight: '30px', width: '120px' }}>
                        {requestData[6] === 'Under Review'
                            ? verifyLoading ? <div style={{ width: '12px', height: '12px' }} className='loader'></div> : 'Approve Request'
                            : requestData[6] === 'Approved' ? 'Assign CA/CS'
                                : requestData[6] === 'Assigned' ? 'Complete'
                                    : 'Pay Amount'}
                    </div>
                    {requestData[6] === 'Under Review' ?
                        <div onClick={() => setShowCancelRequestPopup(true)} className='submit-button-variable'>
                            Close Request
                        </div> : <></>}
                </div>
            }

            {/* View Payment Details button for Paid status */}
            {requestData[6] === 'Paid' ?
                <div
                    onClick={() => setShowPaymentDetailsPopup(true)}
                    className='submit-button-variable'
                    style={{ backgroundColor: '#28a745', borderColor: '#28a745' }}>
                    View Payment Details
                </div>
                : <></>}
        </div>

        {/* Main content */}
        <div style={{ width: '100%', minHeight: '80%', display: 'flex', justifyContent: 'center' }}>
            {/* Left column */}
            <div style={{ width: '30%', display: 'flex', flexDirection: 'column', alignSelf: 'flex-start' }}>
                <div className='content-div-demo' style={{ width: '100%', paddingBottom: '20px' }}>
                    <div style={{ borderBottom: '1px solid black', padding: '10px 20px' }}>
                        <p style={{ fontSize: '22px', fontWeight: '600' }}>Request Summary</p>
                    </div>
                    <div style={{ padding: '20px 0 10px 20px' }}>
                        <p style={{ fontSize: '15px', paddingBottom: '10px' }}>Request ID</p>
                        <p style={{ fontSize: '20px', fontWeight: '600' }}>{requestData[0]}</p>
                    </div>
                    <div style={{ padding: '20px 0 10px 20px' }}>
                        <p style={{ fontSize: '15px', paddingBottom: '10px' }}>Date</p>
                        <p style={{ fontSize: '20px', fontWeight: '600' }}>{dateFormat(requestData[8])}</p>
                    </div>
                    <div style={{ padding: '20px 0 10px 20px' }}>
                        <p style={{ fontSize: '15px', paddingBottom: '10px' }}>Product Service</p>
                        <p style={{ fontSize: '20px', fontWeight: '600' }}>{requestData[2]}</p>
                    </div>
                    <div style={{ padding: '20px 0 10px 20px' }}>
                        <p style={{ fontSize: '15px', paddingBottom: '10px' }}>Status</p>
                        <p style={{ fontSize: '20px', fontWeight: '600', color: requestData[6] === 'Paid' ? '#28a745' : 'green' }}>
                            {requestData[6]}
                        </p>
                    </div>
                </div>

                <div className='content-div-demo' style={{ width: '100%', paddingBottom: '20px', marginTop: '20px' }}>
                    <div style={{ borderBottom: '1px solid black', padding: '10px 20px' }}>
                        <p style={{ fontSize: '22px', fontWeight: '600' }}>Customer Details</p>
                    </div>
                    <div style={{ padding: '20px 0 10px 20px' }}>
                        <p style={{ fontSize: '15px', paddingBottom: '10px' }}>Name</p>
                        <p style={{ fontSize: '20px', fontWeight: '600' }}>{requestData[1]}</p>
                        <p style={{ fontSize: '16px', fontWeight: '400', marginTop: '5px' }}>{requestData[3]}</p>
                        <p style={{ fontSize: '16px', fontWeight: '400', marginTop: '5px' }}><span>+91</span> {requestData[4]}</p>
                    </div>
                </div>
            </div>

            {/* Right column */}
            <div style={{ width: '60%', display: 'flex', flexDirection: 'column', marginLeft: '20px', alignSelf: 'flex-start' }}>
                <div className='content-div-demo' style={{ width: '90%', paddingBottom: '20px', marginLeft: '50px' }}>
                    <div style={{ borderBottom: '1px solid black', padding: '10px 20px' }}>
                        <p style={{ fontSize: '22px', fontWeight: '600' }}>Uploaded Documents</p>
                    </div>
                    {documents.map((item, index) => (
                        <div key={index}>
                            <div style={{ padding: '20px 30px 10px 20px', display: 'flex', justifyContent: 'space-between' }}>
                                <p style={{ fontSize: '18px', fontWeight: '600' }}>{item[1]}</p>
                                <div style={{ display: 'flex' }}>
                                    <div onClick={() => showRequestDocument(item[0])} className='view-button'>view</div>
                                    <div style={{ marginLeft: '10px' }} onClick={() => downloadRequestDocument(item[0], item[1])} className='view-button'>download</div>
                                </div>
                            </div>
                            {documents.length !== index + 1 ? <hr style={{ margin: '0 30px' }} /> : ''}
                        </div>
                    ))}
                </div>

                <div className='content-div-demo' style={{ width: '90%', paddingBottom: '20px', marginTop: '20px', marginLeft: '50px' }}>
                    <div style={{ borderBottom: '1px solid black', padding: '10px 20px' }}>
                        <p style={{ fontSize: '22px', fontWeight: '600' }}>Activity Log</p>
                    </div>
                    <div style={{ padding: '20px 30px 10px 20px', display: 'flex', justifyContent: 'space-between' }}>
                        <p style={{ fontSize: '18px', fontWeight: '500' }}>request created by {requestData[21]}</p>
                        <p style={{ fontSize: '15px', fontWeight: '400' }}>{dateFormat(requestData[8])}</p>
                    </div>
                    {(requestData[6] === 'Approved' || requestData[6] === 'Assigned' || requestData[6] === 'Completed' || requestData[6] === 'Paid') &&
                        <div style={{ padding: '20px 30px 10px 20px', display: 'flex', justifyContent: 'space-between' }}>
                            <p style={{ fontSize: '18px', fontWeight: '500' }}>request verified by admin</p>
                            <p style={{ fontSize: '15px', fontWeight: '400' }}>{dateFormat(requestData[12])}</p>
                        </div>
                    }
                    {(requestData[6] === 'Assigned' || requestData[6] === 'Completed' || requestData[6] === 'Paid') &&
                        <div style={{ padding: '20px 30px 10px 20px', display: 'flex', justifyContent: 'space-between' }}>
                            <p style={{ fontSize: '18px', fontWeight: '500' }}>request assigned to {requestData[22] || 'CA/CS'} (ID: {requestData[9]})</p>
                            <p style={{ fontSize: '15px', fontWeight: '400' }}>{dateFormat(requestData[15])}</p>
                        </div>
                    }
                    {(requestData[6] === 'Completed' || requestData[6] === 'Paid') &&
                        <div style={{ padding: '20px 30px 10px 20px', display: 'flex', justifyContent: 'space-between' }}>
                            <p style={{ fontSize: '18px', fontWeight: '500' }}>request completed by CA/CS</p>
                            <p style={{ fontSize: '15px', fontWeight: '400' }}>{dateFormat(requestData[13])}</p>
                        </div>
                    }
                    {requestData[6] === 'Paid' &&
                        <div style={{ padding: '20px 30px 10px 20px', display: 'flex', justifyContent: 'space-between' }}>
                            <p style={{ fontSize: '18px', fontWeight: '500' }}>payment done by admin</p>
                            <p style={{ fontSize: '15px', fontWeight: '400' }}>{paidInfo.paidAt ? dateFormat(paidInfo.paidAt) : 'today'}</p>
                        </div>
                    }
                    {requestData[6] === 'Rejected' &&
                        <div style={{ padding: '20px 30px 10px 20px', display: 'flex', justifyContent: 'space-between' }}>
                            <p style={{ fontSize: '18px', fontWeight: '500' }}>request rejected by admin</p>
                            <p style={{ fontSize: '15px', fontWeight: '400' }}>{dateFormat(requestData[14])}</p>
                        </div>
                    }
                    <div style={{ height: '10px' }}></div>
                </div>
            </div>
        </div>

        {/* ===== Assign CA/CS Popup ===== */}
        {showPopUp ?
            <div style={{
                border: '1px solid black', borderRadius: '10px',
                position: "fixed", top: "10%", right: '50px', width: "25%", height: "80%",
                backgroundColor: "aliceblue", justifyContent: "center", alignItems: "center"
            }}>
                <h2 style={{ margin: '10px', fontSize: '20px' }}>Select CA/CS</h2>
                <div style={{ height: '80%', overflowY: 'auto', backgroundColor: 'white', border: '1px solid black', margin: '0px 15px', borderRadius: '5px' }}>
                    <ShowCaCsList available_now={true} />
                </div>
                <div style={{ display: 'flex', justifyContent: 'center', marginTop: '10px' }}>
                    <div onClick={() => setShowPopUp(false)} className="button">Cancel</div>
                    <div onClick={async () => {
                        if (assignLoading) return;
                        setAssignLoading(true);
                        if (selectedCaCsId === 0) {
                            alert('Select CA/CS');
                            setAssignLoading(false);
                            return;
                        }
                        const response = await assignCaCs(selectedCaCsId, requestData[0]);
                        if (response === 'success') {
                            requestData[6] = 'Assigned';
                            alert('Service Request Assigned Successfully To CA/CS');
                        } else {
                            alert(response);
                        }
                        fetchData();
                        setShowPopUp(false);
                        setAssignLoading(false);
                    }} className="button">
                        {assignLoading ? <div style={{ width: '12px', height: '12px' }} className='loader'></div> : <span>Assign</span>}
                    </div>
                </div>
            </div>
            : <div></div>}

        {/* ===== Complete Work Popup ===== */}
        {showCompleteWorkPopup ?
            <div style={{
                border: '1px solid black', borderRadius: '10px',
                position: "fixed", top: "10%", right: '50px', width: "25%", height: "80%",
                backgroundColor: "aliceblue", justifyContent: "center", alignItems: "center"
            }}>
                <h2 style={{ margin: '10px', fontSize: '20px' }}>Submit Completed Work</h2>
                <div style={{ alignContent: 'start', justifyItems: 'start', height: '80%', overflowY: 'auto', backgroundColor: 'white', border: '1px solid black', margin: '0px 15px', borderRadius: '5px' }}>
                    <div style={{ flexDirection: 'column', display: 'flex', justifyContent: 'center', margin: '40px 20px', height: '50%', width: '80%' }}>
                        <span className='input-label-demo'>Description</span>
                        <textarea style={{ width: '100%', height: '60%', padding: '10px' }} name="description" id="description" value={description} onChange={(e) => setDescription(e.target.value)}></textarea>
                    </div>
                    <div style={{ display: 'flex', flexDirection: 'column', justifyContent: 'center', margin: '40px 20px' }}>
                        <span className='input-label-demo'>Upload Documents</span>
                        <div style={{ border: 'none', marginTop: '10px' }}>
                            <label htmlFor="MyFiles" style={{ backgroundColor: "#007bff", color: "white", padding: "2px 16px", borderRadius: "8px", cursor: "pointer" }}>
                                Select File
                            </label>
                            <input style={{ height: '25px', marginBottom: '5px', display: 'none' }}
                                onChange={(e) => {
                                    const maxFileLimit = 4;
                                    const maxFileSize = 5 * 1024 * 1024;
                                    if (e.target.files.length > maxFileLimit) {
                                        alert('you can select maximun 4 files');
                                        document.getElementById("MyFiles").value = "";
                                        return;
                                    }
                                    for (let file of e.target.files) {
                                        if (file.size > maxFileSize) {
                                            alert(`File "${file.name}" is too large. Max size is 5 MB.`);
                                            document.getElementById("MyFiles").value = "";
                                            return;
                                        }
                                    }
                                    for (let file of e.target.files) {
                                        const isDuplicate = files.some(f => f.name === file.name && f.size === file.size);
                                        if (!isDuplicate) {
                                            if (files.length + 1 > maxFileLimit) {
                                                alert('you can select maximun 4 files');
                                                return;
                                            }
                                            setMyFiles(prev => [...prev, file]);
                                        }
                                    }
                                    e.target.value = "";
                                }} type="file" id='MyFiles' multiple />
                            <div style={{ display: 'flex', marginTop: '10px' }}>
                                {files.length === 0 ? <span>No file selected</span> :
                                    files.map((item, index) => (
                                        <div key={index} style={{ display: 'flex' }}>
                                            <div style={{ width: '70px', overflow: 'clip', height: '20px' }}>{item.name}</div>
                                            <img onClick={() => setMyFiles(files => files.filter((_, i) => i !== index))}
                                                style={{ height: '20px', marginRight: '15px' }} src={CancleSvg} alt="" />
                                        </div>
                                    ))}
                            </div>
                        </div>
                    </div>
                </div>
                <div style={{ display: 'flex', justifyContent: 'center', marginTop: '10px' }}>
                    <div onClick={() => setShowCompleteWorkPopup(false)} className="button">Cancel</div>
                    <div onClick={async () => {
                        if (completeLoading) return;
                        setCompleteLoading(true);
                        const response = await completeWork(requestData[0], description, files);
                        if (response === 'submitted') {
                            requestData[6] = 'Completed';
                            alert('All Completed Documents Uploaded Successfully');
                        } else {
                            alert(response);
                        }
                        fetchData();
                        setShowCompleteWorkPopup(false);
                        setCompleteLoading(false);
                    }} className="button">
                        {completeLoading ? <div style={{ width: '12px', height: '12px' }} className='loader'></div> : <div>Submit</div>}
                    </div>
                </div>
            </div>
            : <div></div>}

        {/* ===== Close Request Popup ===== */}
        {showCancelRequestPopup ?
            <div style={{
                border: '1px solid black', borderRadius: '10px',
                position: "fixed", top: "10%", right: '50px', width: "25%", height: "60%",
                backgroundColor: "aliceblue", justifyContent: "center", alignItems: "center"
            }}>
                <h2 style={{ margin: '10px', fontSize: '20px' }}>Close Request</h2>
                <div style={{ alignContent: 'start', justifyItems: 'start', height: '70%', overflowY: 'auto', backgroundColor: 'white', border: '1px solid black', margin: '0px 15px', borderRadius: '5px' }}>
                    <div style={{ flexDirection: 'column', display: 'flex', justifyContent: 'center', margin: '40px 20px', height: '50%', width: '80%' }}>
                        <span className='input-label-demo'>Description</span>
                        <textarea style={{ width: '100%', height: '60%', padding: '10px' }} name="cancelDescription" id="cancelDescription" value={cancelDescription} onChange={(e) => setCancelDescription(e.target.value)}></textarea>
                    </div>
                </div>
                <div style={{ display: 'flex', justifyContent: 'center', marginTop: '10px' }}>
                    <div onClick={() => setShowCancelRequestPopup(false)} className="button">Cancel</div>
                    <div onClick={async () => {
                        if (cancelRequestLoading) return;
                        setCancelRequestLoading(true);
                        const response = await updateRequestStatus(requestData[0], "Rejected", "instruction");
                        if (response === 'success') {
                            requestData[6] = 'Rejected';
                            alert('Request Status changed');
                        } else {
                            alert(response);
                        }
                        fetchData();
                        setShowCancelRequestPopup(false);
                        setCancelRequestLoading(false);
                    }} className="button">
                        {cancelRequestLoading ? <div style={{ width: '12px', height: '12px' }} className='loader'></div> : <div>Submit</div>}
                    </div>
                </div>
            </div>
            : <div></div>}

        {/* ===== Pay Amount Popup ===== */}
        {showPayAmountPopup ?
            <div style={overlayStyle} onClick={() => setShowPayAmountPopup(false)}>
                <div style={modalStyle} onClick={(e) => e.stopPropagation()}>
                    <h2 style={{ margin: '0 0 20px 0', fontSize: '20px', fontWeight: '700', color: '#2c3e50' }}>
                        💳 Payment Request
                    </h2>

                    {/* CA/CS Bank Details Section */}
                    <div style={{ marginBottom: '20px', padding: '15px', backgroundColor: '#f0f7ff', borderRadius: '8px', border: '1px solid #cce5ff' }}>
                        <p style={{ margin: '0 0 10px 0', fontWeight: '700', color: '#004085', fontSize: '16px' }}>📍 CA/CS Bank Details</p>
                        {caCsBankLoading ? (
                            <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                                <div style={{ width: '14px', height: '14px' }} className='loader'></div>
                                <span style={{ fontSize: '14px', color: '#666' }}>Fetching details...</span>
                            </div>
                        ) : caCsBankDetails ? (
                            <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '8px', fontSize: '14px' }}>
                                <div>
                                    <span style={{ color: '#666', display: 'block' }}>Bank Name</span>
                                    <span style={{ fontWeight: '600' }}>{caCsBankDetails.bankName}</span>
                                </div>
                                <div>
                                    <span style={{ color: '#666', display: 'block' }}>Account Name</span>
                                    <span style={{ fontWeight: '600' }}>{caCsBankDetails.accountName}</span>
                                </div>
                                <div>
                                    <span style={{ color: '#666', display: 'block' }}>Account Number</span>
                                    <span style={{ fontWeight: '600' }}>{caCsBankDetails.accountNumber}</span>
                                </div>
                                <div>
                                    <span style={{ color: '#666', display: 'block' }}>IFSC Code</span>
                                    <span style={{ fontWeight: '600' }}>{caCsBankDetails.ifscCode}</span>
                                </div>
                                {caCsBankDetails.upiId && (
                                    <div style={{ gridColumn: 'span 2' }}>
                                        <span style={{ color: '#666', display: 'block' }}>UPI ID</span>
                                        <span style={{ fontWeight: '600', color: '#28a745' }}>{caCsBankDetails.upiId}</span>
                                    </div>
                                )}
                            </div>
                        ) : (
                            <p style={{ color: '#721c24', fontSize: '14px', margin: 0 }}>No bank details found for this CA/CS.</p>
                        )}
                    </div>

                    <div style={{ marginBottom: '14px' }}>
                        <label className='input-label-demo'>Amount (₹) *</label>
                        <input
                            type='number' min='0'
                            style={{ width: '100%', padding: '8px 12px', border: '1px solid #ccc', borderRadius: '6px', marginTop: '4px', boxSizing: 'border-box' }}
                            value={payAmount}
                            onChange={(e) => setPayAmount(e.target.value)}
                            placeholder='Enter amount'
                        />
                    </div>
                    <div style={{ marginBottom: '14px' }}>
                        <label className='input-label-demo'>Payment Method *</label>
                        <select
                            style={{ width: '100%', padding: '8px 12px', border: '1px solid #ccc', borderRadius: '6px', marginTop: '4px', boxSizing: 'border-box' }}
                            value={paymentMethod}
                            onChange={(e) => setPaymentMethod(e.target.value)}>
                            <option value='Bank Transfer'>Bank Transfer</option>
                            <option value='UPI'>UPI</option>
                            <option value='Cash'>Cash</option>
                            <option value='Cheque'>Cheque</option>
                        </select>
                    </div>
                    <div style={{ marginBottom: '14px' }}>
                        <label className='input-label-demo'>Transaction ID</label>
                        <input
                            type='text'
                            style={{ width: '100%', padding: '8px 12px', border: '1px solid #ccc', borderRadius: '6px', marginTop: '4px', boxSizing: 'border-box' }}
                            value={transactionId}
                            onChange={(e) => setTransactionId(e.target.value)}
                            placeholder='Optional transaction/reference ID'
                        />
                    </div>
                    <div style={{ marginBottom: '20px' }}>
                        <label className='input-label-demo'>Notes</label>
                        <textarea
                            style={{ width: '100%', padding: '8px 12px', border: '1px solid #ccc', borderRadius: '6px', marginTop: '4px', boxSizing: 'border-box', minHeight: '70px', resize: 'vertical' }}
                            value={paymentNotes}
                            onChange={(e) => setPaymentNotes(e.target.value)}
                            placeholder='Optional notes'
                        />
                    </div>
                    <div style={{ display: 'flex', justifyContent: 'flex-end', gap: '10px' }}>
                        <div onClick={() => setShowPayAmountPopup(false)} className='button'>Cancel</div>
                        <div
                            onClick={async () => {
                                if (payLoading) return;
                                if (!payAmount || Number(payAmount) <= 0) {
                                    alert('Please enter a valid amount');
                                    return;
                                }
                                setPayLoading(true);
                                const response = await adminPayAmount(
                                    requestData[0],
                                    Number(payAmount),
                                    paymentMethod,
                                    transactionId,
                                    paymentNotes
                                );
                                if (response === 'success') {
                                    requestData[6] = 'Paid';
                                    setPaidInfo({
                                        amount: payAmount,
                                        method: paymentMethod,
                                        txnId: transactionId,
                                        notes: paymentNotes,
                                        paidAt: new Date().toISOString()
                                    });
                                    alert('Payment submitted successfully! Request status updated to Paid.');
                                    setShowPayAmountPopup(false);
                                    fetchData();
                                } else {
                                    alert(response || 'Failed to submit payment. Please try again.');
                                }
                                setPayLoading(false);
                            }}
                            className='button'
                            style={{ backgroundColor: '#28a745', borderColor: '#28a745' }}>
                            {payLoading ? <div style={{ width: '12px', height: '12px' }} className='loader'></div> : 'Submit Payment'}
                        </div>
                    </div>
                </div>
            </div>
            : <div></div>}

        {/* ===== Payment Details Modal ===== */}
        {showPaymentDetailsPopup ?
            <div style={overlayStyle} onClick={() => setShowPaymentDetailsPopup(false)}>
                <div style={modalStyle} onClick={(e) => e.stopPropagation()}>
                    <h2 style={{ margin: '0 0 20px 0', fontSize: '20px', fontWeight: '700', color: '#2c3e50' }}>
                        ✅ Payment Details
                    </h2>
                    <div style={{ background: '#f8f9fa', borderRadius: '8px', padding: '20px', border: '1px solid #e9ecef' }}>
                        <table style={{ width: '100%', borderCollapse: 'collapse' }}>
                            <tbody>
                                <tr>
                                    <td style={{ padding: '8px 0', color: '#6c757d', width: '140px', fontWeight: '500' }}>Request ID:</td>
                                    <td style={{ padding: '8px 0', fontWeight: '600' }}>#{requestData[0]}</td>
                                </tr>
                                <tr>
                                    <td style={{ padding: '8px 0', color: '#6c757d', fontWeight: '500' }}>Amount Paid:</td>
                                    <td style={{ padding: '8px 0', fontWeight: '700', color: '#28a745', fontSize: '18px' }}>₹{paidInfo.amount}</td>
                                </tr>
                                <tr>
                                    <td style={{ padding: '8px 0', color: '#6c757d', fontWeight: '500' }}>Payment Method:</td>
                                    <td style={{ padding: '8px 0', fontWeight: '600' }}>{paidInfo.method}</td>
                                </tr>
                                <tr>
                                    <td style={{ padding: '8px 0', color: '#6c757d', fontWeight: '500' }}>Transaction ID:</td>
                                    <td style={{ padding: '8px 0', fontWeight: '600' }}>{paidInfo.txnId || '—'}</td>
                                </tr>
                                <tr>
                                    <td style={{ padding: '8px 0', color: '#6c757d', fontWeight: '500' }}>Notes:</td>
                                    <td style={{ padding: '8px 0' }}>{paidInfo.notes || '—'}</td>
                                </tr>
                                <tr>
                                    <td style={{ padding: '8px 0', color: '#6c757d', fontWeight: '500' }}>Paid On:</td>
                                    <td style={{ padding: '8px 0' }}>{paidInfo.paidAt ? dateFormat(paidInfo.paidAt) : '—'}</td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                    <div style={{ display: 'flex', justifyContent: 'flex-end', marginTop: '20px' }}>
                        <div onClick={() => setShowPaymentDetailsPopup(false)} className='button'>Close</div>
                    </div>
                </div>
            </div>
            : <div></div>}

    </div>
}
